import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    window.history.replaceState({}, document.title, window.location.pathname);

    (async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const response = await fetch(`${API}/auth/session`, {
          method: "POST",
          credentials: "include",
          headers: { "X-Session-ID": sessionId },
        });
        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          throw new Error(body.detail || "Session exchange failed");
        }
        const user = await response.json();
        await signIn(user);
        navigate("/dashboard", { replace: true, state: { user } });
      } catch (error) {
        navigate("/", { replace: true, state: { authError: error.message } });
      }
    })();
  }, [navigate, signIn]);

  return <div className="min-h-screen bg-[#FBF6F4]" data-testid="auth-callback" />;
}
